<template>
    <b-modal id="manual_config_manager_modal" size="lg">
        <template slot="modal-title">Manually Change the project Config</template>
        <b-form-group>
            <b-form-group>
                <prism-editor emitEvents
                              :line-numbers="true"
                              v-model="inner_data"
                              language="json"
                              required>
                </prism-editor>
                <b-form-invalid-feedback :state="validateData">
                    Data is invalid.
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="validateData">
                    Data is okay.
                </b-form-valid-feedback>
            </b-form-group>
        </b-form-group>
        <template slot="modal-footer">
            <b-button block
                      variant="primary"
                      @click="save">
                Save config
                <v-icon dark>mdi-content-save-outline</v-icon>
            </b-button>
        </template>
    </b-modal>
</template>
<script>
    import ProjectRepository from '../../../repositories/project.repository'
    import PrismEditor from 'vue-prism-editor';

    export default {
        props: {
            projectConfig: {
                type: Object,
                default: {}
            },
            projectId: {
                type: Number,
                default: -1
            }
        },
        components: {
            PrismEditor,
        },
        data() {
            return {
                inner_data: '{}'
            }
        },
        methods: {
            save() {
                if (this.dataIsValid()) {
                    this.$emit('show-loading-pop-up', "Saving the project Config");
                    this.$bvModal.hide('manual_config_manager_modal');
                    ProjectRepository.saveProjectConfig(this.inner_data, this.projectId).then(res => {
                        this.$emit('reset-loading-pop-up');
                        this.$emit('saved-project-config');
                        this.$bvToast.toast('Successfully saved the project config', {
                            title: `Config save successful.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$bvModal.show('manual_config_manager_modal');
                        console.error(error);
                        this.$bvToast.toast('Looks like something went wrong on the server while saving the project config.', {
                            title: `Config save error.`,
                            variant: 'danger',
                            solid: true
                        });
                    });
                }
            },
            dataIsValid() {
                let valid = false;
                try {
                    let json = JSON.parse(this.inner_data);
                    if (json && typeof json === "object") valid = true;
                } catch (err) {
                    window.console.log(err);
                }
                return valid;
            },
        },
        computed: {
            validateData() {
                return this.dataIsValid();
            }
        },
        watch: {
            projectConfig() {
                if (this.projectConfig !== null) {
                    this.inner_data = JSON.stringify(this.projectConfig, null, 2);
                }
            }
        }
    }
</script>
